import { useLocation, useOutlet } from 'react-router-dom'
import Graph from './Graph'
import GraphBoundary from './GraphBoundary'
import SideMenu from './SideMenu'
import Drawer from './Drawer'
import PhoneShell from './PhoneShell'
import BillingBanner from './BillingBanner'
import TerminalManager from './TerminalManager'
import NodeAttachDialog from './NodeAttachDialog'
import ModalSearch from './ModalSearch'
import useAccessRequestNotifier from '../hooks/useAccessRequestNotifier'
import useSearchHotkey from '../hooks/useSearchHotkey'
import { isNativePhone } from '../lib/nativeApp'

function Layout() {
  const location = useLocation()
  const outlet = useOutlet()
  const isDrawerRoute = /^\/(nodes|networks|account)/.test(location.pathname)
  useAccessRequestNotifier()
  useSearchHotkey()

  // ⚠ The noBGP app on a PHONE (mobile/, nativeApp.ts): List, Graph and Map in a bar at the
  // bottom (PhoneShell.tsx); List is the drawer, full screen. No side menu. The other routes
  // (Usage, Billing, the modals) draw over it as they do over the graph. A tablet and every
  // browser keep the layout below.
  if (isNativePhone) {
    return (
      <>
        <BillingBanner />
        <PhoneShell drawer={isDrawerRoute ? outlet : null}>
          {!isDrawerRoute && outlet}
          <TerminalManager />
          <NodeAttachDialog />
          <ModalSearch />
        </PhoneShell>
      </>
    )
  }

  return (
    <>
      <GraphBoundary>
        <Graph />
      </GraphBoundary>
      <BillingBanner />
      <Drawer>{isDrawerRoute ? outlet : null}</Drawer>
      {!isDrawerRoute && outlet}
      <TerminalManager />
      <NodeAttachDialog />
      <ModalSearch />
      <SideMenu />
    </>
  )
}

export default Layout
